export default function ReportAutomation() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ⑧ 利益レポートの自動化
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold mb-6">社長が毎日見るのは：</h3>
            <div className="space-y-4">
              {[
                { label: '売上', icon: 'ri-money-dollar-circle-line', color: 'bg-green-500' },
                { label: '粗利', icon: 'ri-funds-line', color: 'bg-blue-500' },
                { label: '利益率', icon: 'ri-percent-line', color: 'bg-purple-500' },
                { label: '広告費', icon: 'ri-megaphone-line', color: 'bg-orange-500' },
                { label: 'ROAS', icon: 'ri-line-chart-line', color: 'bg-pink-500' },
                { label: '在庫回転', icon: 'ri-refresh-line', color: 'bg-teal-500' }
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-4 bg-white/10 rounded-lg p-4">
                  <div className={`w-10 h-10 ${item.color} rounded-lg flex items-center justify-center`}>
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <span className="font-bold text-lg">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="flex flex-col justify-center space-y-6">
            <div className="bg-primary/5 border-2 border-primary rounded-xl p-8">
              <h4 className="text-xl font-bold text-gray-900 mb-6">全部：</h4>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-file-excel-line text-xl text-green-600"></i>
                  </div>
                  <span className="text-gray-700 font-medium">Sheets</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className="ri-dashboard-line text-xl text-blue-600"></i>
                  </div>
                  <span className="text-gray-700 font-medium">Looker Studio</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <i className="ri-refresh-line text-xl text-primary"></i>
                  </div>
                  <span className="text-gray-700 font-medium">自動更新</span>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-xl p-8 shadow-lg">
              <div className="flex items-center gap-3">
                <i className="ri-arrow-right-line text-3xl"></i>
                <p className="text-xl font-bold">経営ダッシュボード完成。</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-gray-50 rounded-2xl p-8">
          <div className="text-center">
            <div className="inline-block bg-primary text-white rounded-full px-6 py-3 font-bold text-lg mb-4">
              リアルタイム可視化
            </div>
            <p className="text-gray-700 text-lg">
              スマホからでも、いつでもどこでも経営数値を確認可能
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
